import { useMemo } from 'react';
import { EventMetricsProvider } from 'src/contexts/EventMetricsContext/EventMetricsContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { EventWithData, Feature } from 'src/WebApiController';

import { EventSectionClearingPricesWidgetsContainer } from '../../../DashboardSection/Widgets/EventSectionClearingPrices';
import { EventSupplyWidgetsContainer } from '../../../DashboardSection/Widgets/EventSupply/EventSupplyContainer';
import { EventWebsiteMetricWidgetsContainer } from '../../../DashboardSection/Widgets/EventWebsiteMetric';
import { SellerEventPerformanceMetricWidgetsContainer } from '../../../DashboardSection/Widgets/SellerEventPerformanceMetric';

export const DashboardSectionMobile = ({
  event,
  isOnSaleEvent,
}: {
  event: EventWithData;
  isOnSaleEvent?: boolean;
}) => {
  const hasBlockInventorySummaryStatsFeature = useUserHasFeature(
    Feature.BlockInventorySummaryStats
  );

  const showYourStats = useMemo(() => {
    if (hasBlockInventorySummaryStatsFeature) {
      return false;
    }

    return !isOnSaleEvent;
  }, [hasBlockInventorySummaryStatsFeature, isOnSaleEvent]);

  return (
    <EventMetricsProvider event={event.event} isOnSaleEvent={isOnSaleEvent}>
      <Stack gap="l" style={{ marginTop: vars.spacing.m }} direction="column">
        {showYourStats && <SellerEventPerformanceMetricWidgetsContainer />}
        <EventSupplyWidgetsContainer />
        {/* Removed "Demand Factors" until we have more data to populate here. See SUP-639
       <EventDemandFactorWidgetsContainer event={event} />
        */}
        <EventWebsiteMetricWidgetsContainer />
        <EventSectionClearingPricesWidgetsContainer />
      </Stack>
    </EventMetricsProvider>
  );
};
